// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 410px) {
  .signal34-authentication {
    max-width: 380px;
    width: 380px;
  }
}
.signal34-authentication-google {
  background-color: #4285F4;
  color: white;
  height: 41px ;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 7px;
  padding-right: 7px;
  border-radius: 4px;
  margin-top: 9px ;
  width: 100%;
  display: table;
  cursor: pointer;
}

.signal34-authentication-google span,
.signal34-authentication-facebook span {
  font-size: 12.2pt;
  display: table-cell;
  padding-top: 8px;
  text-align: center;
}

.signal34-authentication-google span+img,
.signal34-authentication-facebook span+img { 
  float: left;
  width: 24px ;
  height: 24px ;
  display: inline-block;
  vertical-align: middle;
  margin-top: 8px;
}

.signal34-authentication-facebook {
  background-color: #4267B2;
  color: white;
  height: 41px ;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 7px;
  padding-right: 7px;
  border-radius: 4px;
  width: 100%;
  display: table;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/styles/Authentication.css"],"names":[],"mappings":"AAAA;EACE;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,eAAe;AACjB","sourcesContent":["@media only screen and (min-width: 410px) {\n  .signal34-authentication {\n    max-width: 380px;\n    width: 380px;\n  }\n}\n.signal34-authentication-google {\n  background-color: #4285F4;\n  color: white;\n  height: 41px ;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  padding-left: 7px;\n  padding-right: 7px;\n  border-radius: 4px;\n  margin-top: 9px ;\n  width: 100%;\n  display: table;\n  cursor: pointer;\n}\n\n.signal34-authentication-google span,\n.signal34-authentication-facebook span {\n  font-size: 12.2pt;\n  display: table-cell;\n  padding-top: 8px;\n  text-align: center;\n}\n\n.signal34-authentication-google span+img,\n.signal34-authentication-facebook span+img { \n  float: left;\n  width: 24px ;\n  height: 24px ;\n  display: inline-block;\n  vertical-align: middle;\n  margin-top: 8px;\n}\n\n.signal34-authentication-facebook {\n  background-color: #4267B2;\n  color: white;\n  height: 41px ;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  padding-left: 7px;\n  padding-right: 7px;\n  border-radius: 4px;\n  width: 100%;\n  display: table;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
